import { withTranslation } from 'react-i18next';
import TaxesSection from './TaxesSection';
import { IItemDetailsSection } from '../types';
import sectionHOC from '@app/hocs/sectionHOC';

export default withTranslation()(sectionHOC<IItemDetailsSection>(TaxesSection, 'items'));
